import styled from 'styled-components';

const AnalyticsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Column = styled.div`
  flex: 1;
`;

const Header = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;

const Row = styled.div`
  display: flex;
  gap: 16px;
`;

export { AnalyticsWrapper, Column, Header, Row };
